<div class="flex flex-col text-lightMode-800 dark:text-darkMode-100 bg-lightCardBG dark:bg-darkCardBG min-w-[15rem]">
    <div class="w-full p-8">
        <p class="text-lg">
            توجه
        </p>
        <p class="text-md mt-5 text-lightMode-700 dark:text-darkMode-200">
            {{message|convertToPersian}}
        </p>
    </div>
    <div class="flex px-5 py-3 bg-lightMode-200 dark:bg-darkMode-700 w-full">
        <button [disabled]="modalService.is_sure" (click)="success()" matRipple class="px-3 py-2 h-[40px] min-w-[70px] rounded-md bg-red-500 text-white text-center flex items-center justify-center focus-visible:outline-none">
            <div *ngIf="modalService.is_sure;else sure" class="lds-ring"><div></div><div></div><div></div><div></div></div>
            <ng-template #sure>{{buttonText}}</ng-template>
        </button>
        <button matRipple (click)="!modalService.is_sure ? failure():''" class="mx-3 px-3 py-2 rounded-md bg-lightCardBG dark:bg-darkCardBG text-lightMode-800 dark:text-darkMode-100 text-center flex items-center justify-center">
            {{negativeText}}
        </button>
    </div>
</div>